import type { ReactNode } from 'react'

import { LightIcon } from '@cash-me/react-components'

import { BuildingIcon, ConstructionIcon, PaintRollerIcon, SecureHouseIcon } from 'components/new-icons'

export type ProjectUseTextCard = {
  id: number
  icon: ReactNode
  title: string
  description: string
}

export type ProjectUseImageCard = {
  id: number
  src: string
  alt: string
}

const CAROUSEL_PATH = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/credito-para-condominio/carousel`
const iconColor = 'var(--colors-neutral-text-contrast-default)'

export const textCards: ProjectUseTextCard[] = [
  {
    id: 0,
    icon: <ConstructionIcon color={iconColor} />,
    title: 'Reformas e obras estruturais',
    description:
      'Preserve a estrutura e a conservação das áreas comuns com recursos para projetos como reforma de fachada, recuperação de cobertura, impermeabilização, cobertura de garagem, individualização de água ou gás.'
  },
  {
    id: 1,
    icon: <SecureHouseIcon color={iconColor} />,
    title: 'Modernização e segurança',
    description:
      'Atualize sistemas e equipamentos que fazem parte da rotina dos moradores, como elevadores, controle de acesso, portaria remota, portaria virtual e demais estruturas das áreas comuns.'
  },
  {
    id: 2,
    icon: <LightIcon color={iconColor} />,
    title: 'Eficiência energética',
    description:
      'Invista em soluções que podem contribuir para uma gestão mais eficiente dos recursos do condomínio, como energia solar, iluminação LED, automação e modernização da infraestrutura elétrica.'
  },
  {
    id: 3,
    icon: <PaintRollerIcon color={iconColor} />,
    title: 'Reparos e obras emergenciais',
    description:
      'Alguns problemas não podem esperar. O crédito pode ser uma alternativa a ser avaliada para corrigir vazamentos, realizar reparos estruturais, recuperar áreas comuns e preservar a infraestrutura do empreendimento.'
  },
  {
    id: 4,
    icon: <BuildingIcon color={iconColor} />,
    title: 'Lazer e cuidado',
    description:
      'Valorize o bem-estar dos moradores com investimentos em academias, brinquedotecas, parquinhos infantis, cowork, lavanderias coletivas, áreas de convivência e outras melhorias voltadas à qualidade de vida no condomínio.'
  }
]

export const imageCards: ProjectUseImageCard[] = [
  {
    id: 0,
    src: `${CAROUSEL_PATH}/reformas-obras-estruturais.webp`,
    alt: 'Fachada de um condomínio com andaimes montados durante a obra'
  },
  {
    id: 1,
    src: `${CAROUSEL_PATH}/modernizacao-seguranca.webp`,
    alt: 'Mão pressionando o botão do painel de um elevador'
  },
  {
    id: 2,
    src: `${CAROUSEL_PATH}/eficiencia-energetica.webp`,
    alt: 'Placas de energia solar instaladas no telhado de um edifício'
  },
  {
    id: 3,
    src: `${CAROUSEL_PATH}/reparos-emergenciais.webp`,
    alt: 'Tubulação hidráulica aparente sob a laje da garagem'
  },
  {
    id: 4,
    src: `${CAROUSEL_PATH}/lazer-cuidado.webp`,
    alt: 'Academia do condomínio equipada e iluminada'
  }
]
